import { render } from "./CampaignItem.vue?vue&type=template&id=5439538e&scoped=true"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import "./CampaignItem.vue?vue&type=style&index=0&id=5439538e&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5439538e"]])

export default __exports__